import * as React from 'react';
import { Input as InputComponent, IInputProps } from '@pushwoosh/ui/lib/atoms/Input';

// Styles
import styles from './styles/styles.scss';

export function Input(props: IInputProps): JSX.Element {
  return <InputComponent className={styles['custom-input']} {...props} />;
}
